<template>
  <div 
    :class="baseTagClasses" 
    class="base-tag"
  >
    <span class="base-tag__span">
      <slot />
      {{ renewalStatusText }}
      {{ userRoleText }}
    </span>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { formatRenewalStatusText, formatUserRoleText } from "@utils/format";

const props = defineProps({
  type: {
    type: String,
    default: "primary",
    validator: (value) => [
      "primary",
      "secondary",
      "success",
      "warning",
      "danger",
      "error",
      "attention",
      "info",
      "info-alt",
    ].includes(value),
  },
  renewalStatus: {
    type: String,
    default: "",
  },
  userRole: {
    type: String,
    default: "",
  },
});

const renewalStatusText = computed(() => formatRenewalStatusText(props.renewalStatus));

const userRoleText = computed(() => formatUserRoleText(props.userRole));

const typeModifier = computed(() => {
  if (renewalStatusText.value) {
    const typeMap = {
      Renew: "success",
      Stop: "attention",
      "On hold": "info",
      "Client responsible": "info-alt",
    };
    return typeMap[renewalStatusText.value] || props.type;
  } else if (userRoleText.value) {
    const typeMap = {
      Administrator: "success",
      Editor: "primary",
      Observer: "warning",
    };
    return typeMap[userRoleText.value] || props.type;
  } else {
    return props.type;
  }
});

const baseTagClasses = computed(() => ({
  [`base-tag--type-${typeModifier.value}`]: true,
}));
</script>

<style lang="scss" scoped>
@import "./base-tag.scss";
</style>
